import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { LeadForm } from './components/LeadForm';
import { Footer } from './components/Footer';
import { initPixel, trackPageView } from './utils/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-light-bg font-sans selection:bg-vitality-green selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Benefits data-id="element-3" />
        <LeadForm data-id="element-4" />
      </main>
      <Footer data-id="element-5" />
    </div>;
}